
<template>
  <div>
    <div class="header_local">
      <span class="el-icon-location-outline"></span>
      <span>当前位置: </span>
<!--      <span v-if="Vtext1">{{ Vtext1 }}</span>-->
      <span v-if="Vtext1" class="Vtext1" @click="pathTo">{{ Vtext1 }}</span>
      <span  :style="{color:Vtext3 ? '#999999' :'#1e1e1e'}" v-if="Vtext2"> > {{ Vtext2 }}</span>
      <span  style="color:#1e1e1e" v-if="Vtext3"> > {{ Vtext3 }}</span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    Vtext1: {
      type: String,
      default: () => {
        return "";
      },
    },
    Vtext2: {
      type: String,
      default: () => {
        return "";
      },
    },
    Vtext3: {
      type: String,
      default: () => {
        return "";
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    pathTo() {
      if (this.$route.path.includes('/publishedInquiry') || this.$route.path.includes('/inquiryTakeOrder')) return this.$router.replace('/')
      if (!this.$route.path.includes('queryPrice'))
        this.$router.replace('/placeOrder/placeindexInfo/queryPrice')
    }
  }
};
</script>
<style scoped>
.header_local {
  padding: 22px 0;
}
span {
  color: #999999;
}
.Vtext1:hover {
  color: #FF4D01;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/placeOrder/placeindexInfo/header_local.vue